var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60352 2.60059V21.3846L29.758 52.6916L46.0507 33.9066L18.8962 2.60059H2.60352ZM13.4653 8.86157C16.4523 8.86157 18.8962 11.6796 18.8962 15.1226C18.8962 18.5666 16.4523 21.3846 13.4653 21.3846C10.4783 21.3846 8.03442 18.5666 8.03442 15.1226C8.03442 11.6796 10.4783 8.86157 13.4653 8.86157Z",
    stroke: "#AE8FD6",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/Collection.43eda1ab7e2d97d15fc901017b28206f.svg";
export { ForwardRef as ReactComponent };